var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGetstartedShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 68.91 67.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #5c6570;\n        stroke-width: 1.49px;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-3 {\n        stroke: #662d8e;\n      }\n\n      .cls-3, .cls-4 {\n        stroke-width: 1.4px;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-4 {\n        stroke: #5ac9e6;\n      }\n\n      .cls-6 {\n        fill: #59c9e6;\n      }\n\n      .cls-7 {\n        fill: #5c6570;\n      }\n\n      .cls-8, .cls-9 {\n        fill: #5ac9e6;\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-9 {\n        opacity: .2;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.76,10.28h-1.75c.06-.22,.09-.46,.09-.7,0-1.53-1.24-2.78-2.78-2.78-.03,0-.05,0-.08,0-.29-2.13-2.12-3.78-4.33-3.78-2.42,0-4.38,1.96-4.38,4.38,0,.03,0,.05,0,.08-.89-.45-1.9-.71-2.97-.71C2.95,6.78,0,9.72,0,13.36c0,2.39,1.28,4.48,3.18,5.63,.78,.6,1.75,.95,2.8,.95H22.76c2.54,0,4.62-2.08,4.62-4.62v-.42c0-2.54-2.08-4.62-4.62-4.62Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -3.79,
    y: -0.76,
    width: 34.96,
    height: 24.48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -3.79,
    y: -0.76,
    width: 34.96,
    height: 24.48
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M55.51,15.67h-17.56c.07,.31,.1,.65,.1,1V59.38h17.46c2.15,0,3.88-1.74,3.88-3.88V19.55c0-2.15-1.74-3.88-3.88-3.88Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("image", {
    width: 74,
    height: 52,
    transform: "translate(-4.25 -1.01) scale(.48)",
    xlinkHref: "data:image/png;base64,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"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M30.17,7.41c-.19,0-.37-.07-.51-.2l-1.23-1.12-1.64,.16c-.31,.03-.6-.13-.75-.4-.15-.28-.11-.61,.09-.85l1.03-1.21-.25-1.74c-.05-.32,.11-.62,.39-.78,.28-.15,.62-.12,.86,.09l1.31,1.13,1.69-.27c.31-.05,.62,.1,.78,.37,.16,.28,.13,.62-.07,.86l-1.11,1.35,.18,1.76c.03,.32-.13,.61-.42,.76-.11,.05-.23,.08-.34,.08Zm-1.64-2.38c.19,0,.37,.07,.51,.2l.77,.71-.11-1.14c-.02-.2,.04-.41,.17-.56l.71-.86-1.08,.17c-.22,.04-.45-.03-.62-.18l-.83-.72,.16,1.11c.03,.21-.03,.43-.17,.6l-.66,.78,1.07-.11s.05,0,.07,0Zm2.15-.13h0s0,0,0,0Zm.06-.21h0s0,0,0,0Zm-1.17-2.11h0s0,0,0,0Zm-.23-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M62.82,55.83c-.22-.27-.26-.65-.09-.96l.9-1.68-.65-1.78c-.12-.34-.03-.71,.24-.95s.65-.29,.97-.14l1.64,.8,1.86-.77c.34-.14,.72-.06,.98,.21,.26,.27,.31,.66,.14,.99l-.88,1.78,.78,1.8c.15,.34,.07,.72-.19,.97s-.65,.32-.98,.16l-1.82-.86-1.91,.7c-.34,.13-.72,.03-.96-.25,0,0-.02-.02-.02-.03Zm1.99-2.92c.09,.23,.07,.49-.05,.71l-.57,1.06,1.23-.45c.22-.08,.46-.07,.67,.03l1.17,.55-.5-1.15c-.1-.24-.1-.51,.02-.74l.56-1.13-1.19,.5c-.23,.1-.49,.09-.72-.02l-1.05-.51,.42,1.16Zm-1.13,.41s0,0,0,0h0Zm2.01-2.15s0,0,0,0h0Zm2.17,2.27h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M25.16,.59c.41,.6,.26,1.46-.34,1.88-.62,.44-1.5,.29-1.93-.34-.41-.6-.26-1.46,.33-1.88,.62-.44,1.5-.28,1.93,.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M57.06,66.64c-.22-.27-.25-.64-.09-.95l.81-1.53-.52-1.67c-.11-.35,0-.72,.29-.94,.29-.22,.67-.25,.98-.06l1.41,.84,1.55-.48c.34-.11,.71,0,.93,.28,.2,.29,.26,.65,.09,.97l-.75,1.38,.59,1.64c.12,.34,.02,.72-.26,.96s-.67,.27-.99,.1l-1.49-.83-1.58,.59c-.34,.13-.72,.03-.96-.24,0,0-.02-.02-.03-.03Zm1.7-3.57l.27,.87c.07,.22,.05,.46-.06,.67l-.41,.78,.8-.3c.24-.09,.51-.07,.73,.05l.75,.42-.3-.83c-.08-.23-.07-.49,.05-.71l.38-.7-.81,.25c-.24,.07-.49,.04-.7-.09l-.69-.41Zm-.86-.51h0s0,0,0,0Zm2.2-.15s0,0,0,0h0Zm1.62,1.89h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M65.5,61.5c-.61-.06-1.08-.61-1.04-1.23,.05-.64,.62-1.12,1.26-1.06,.61,.06,1.08,.62,1.04,1.23-.05,.63-.62,1.12-1.26,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M50.65,23.39h-1.18c-.06,0-.12,0-.17,.02-.12,.03-.23,.1-.32,.19-.02,.02-.03,.03-.05,.05-.1,.12-.16,.28-.16,.45v1.87s1.88,0,1.88,0c.39,0,.7-.32,.7-.71v-1.16h0s0-.71,0-.71c0,0-.46,0-.71,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M24.82,49.22h-1.18c-.06,0-.12,0-.17,.02-.12,.03-.23,.1-.32,.19-.02,.02-.03,.03-.05,.05-.1,.12-.16,.28-.16,.45v1.87s1.88,0,1.88,0c.39,0,.7-.32,.7-.71v-1.16h0s0-.71,0-.71c0,0-.46,0-.71,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25.21,27.7h-1.96c-1.12,0-2.03-.92-2.03-2.06v-3.97s3.99,0,3.99,0c1.12,0,2.03,.92,2.03,2.06v3.97h-2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M24.82,25.98h-1.18c-.06,0-.12,0-.17-.02-.12-.03-.23-.1-.32-.19-.02-.02-.03-.03-.05-.05-.1-.12-.16-.28-.16-.45v-1.87s1.88,0,1.88,0c.39,0,.7,.32,.7,.71v1.16h0s0,.71,0,.71c0,0-.46,0-.71,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M27.25,49.53v1.96c0,1.12-.92,2.03-2.06,2.03h-3.97s0-3.99,0-3.99c0-1.12,.92-2.03,2.06-2.03h1.91s2.06,0,2.06,0v2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M25.53,49.92v1.18c0,.06,0,.12-.02,.17-.03,.12-.1,.23-.19,.32-.02,.02-.03,.03-.05,.05-.12,.1-.28,.16-.45,.16h-1.87s0-1.88,0-1.88c0-.39,.32-.7,.71-.7h1.16s0,0,0,0h.71s0,.46,0,.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M47.14,25.58v-1.96c0-1.12,.92-2.03,2.06-2.03h3.97s0,3.99,0,3.99c0,1.12-.92,2.03-2.06,2.03h-1.91s-2.06,0-2.06,0v-2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M48.77,25.19v-1.18c0-.06,0-.12,.02-.17,.03-.12,.1-.23,.19-.32,.02-.02,.03-.03,.05-.05,.12-.1,.28-.16,.45-.16h1.87s0,1.88,0,1.88c0,.39-.32,.7-.71,.7h-1.16s0,0,0,0h-.71s0-.46,0-.7Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 33.49,
    y: 33.21,
    width: 8.66,
    height: 8.66,
    rx: 2.34,
    ry: 2.34
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 45.21,
    cy: 32.58,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 45.21,
    cy: 42.51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 49.04,
    cy: 37.53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 52.88,
    cy: 32.58,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 52.88,
    cy: 37.53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 29.86,
    cy: 32.58,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 29.86,
    cy: 37.53,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 29.86,
    cy: 42.51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 33.7,
    cy: 22.68,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 33.7,
    cy: 27.63,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 33.7,
    cy: 52.4,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 37.54,
    cy: 22.68,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 37.54,
    cy: 47.45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 41.37,
    cy: 22.68,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 41.37,
    cy: 27.63,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 41.37,
    cy: 47.45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 41.37,
    cy: 52.4,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 22.22,
    cy: 32.58,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 22.22,
    cy: 42.51,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 26.06,
    cy: 32.58,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 26.06,
    cy: 37.53,
    r: 1
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.39,51.14v4.37c0,2.15-1.74,3.88-3.88,3.88H19.57c-2.15,0-3.88-1.74-3.88-3.88V19.57c0-2.15,1.74-3.88,3.88-3.88H55.51c2.15,0,3.88,1.74,3.88,3.88v16.13"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.08,52.76v-3.53c0-3.35,2.72-6.07,6.07-6.07h5.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "58.98 47.78 63.61 43.16 59.27 38.82"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetstartedShare);
export default __webpack_public_path__ + "static/media/getstarted_share.59958a8753f9d451c604c49da4d20e3b.svg";
export { ForwardRef as ReactComponent };